import APIUtils from '@spothero/utils/api';
import SHGlobals from 'sh-globals';
import SHAnalytics from 'sh-analytics';

const FacilityAPI = {
    getAirportData(spotId) {
        return APIUtils.get(`facilities/${spotId}/airport/`, {
            include: `${SHGlobals.FACILITY_INCLUDES.replace(/facility./g, '')},checkout_url`
        });
    },

    getRecommendedSpots(data) {
        return APIUtils.get('facilities/rates/', data);
    },

    getRates({spotId, starts, ends, eventId, includeFacility = false, experimentGroupId = null}) {
        const includes = 'transient,monthly';
        const allIncludes = (includeFacility) ? `${includes},${SHGlobals.FACILITY_INCLUDES}` : includes;
        const segmentId = SHAnalytics.getSegmentAnonymousId();
        const data = {
            starts,
            include: allIncludes
        };

        if (segmentId) {
            data.segment_id = segmentId;
            data.mixpanel_id = segmentId;
        }

        if (ends) {
            data.ends = ends;
        }

        if (eventId) {
            data.eid = eventId;
        }

        if (experimentGroupId) {
            data.experiment_group_id = experimentGroupId;
        }

        return APIUtils.get(`facilities/${spotId}/rates/`, data);
    },

    getAirportRates({spotId, starts, ends, includeFacility = false, experimentGroupId = null}) {
        const includes = 'transient';
        const allIncludes = (includeFacility) ? `${includes},${SHGlobals.FACILITY_INCLUDES},facility.facility_url` : includes;
        const segmentId = SHAnalytics.getSegmentAnonymousId();
        const data = {
            starts,
            include: allIncludes
        };

        if (segmentId) {
            data.segment_id = segmentId;
            data.mixpanel_id = segmentId;
        }

        if (ends) {
            data.ends = ends;
        }

        if (experimentGroupId) {
            data.experiment_group_id = experimentGroupId;
        }

        return APIUtils.get(`facilities/${spotId}/rates/airport/`, data);
    }
};

export default FacilityAPI;



// WEBPACK FOOTER //
// ./spothero/static/main/js/api/facility.js